import {filterNumberMax, filterSpeed, getDateInTimeZone, isSubarray, mapValidationData} from "@/utils/utils";

export default {
    getSelectedValidationProject: (state) => {
        return state.selectedValidationProject
    },
    getSelectedValidationDevice: (state) => {
        return state.selectedValidationDevice
    },
    getFilteredValidationProjects: (state, getters, _, rootGetters) => {
        let allProjects = rootGetters['projectsModule/getAllProjects']
        if (allProjects.length > 0) {
            let filteredProjects = allProjects
            if (state.searchQueryData.query.length > 0) {
                filteredProjects = allProjects.filter(project => project.name && project.name.toLowerCase().includes(state.searchQueryData.query.toLowerCase()))
            }
            if (state.searchQueryData.active.value !== 'ALL') {
                filteredProjects = filteredProjects.filter(project => project.status === state.searchQueryData.active.value)
            }
            if (state.searchQueryData.projectType.value !== 'ALL') {
                filteredProjects = filteredProjects.filter(project => project.types.includes(state.searchQueryData.projectType.value))
            }

            if (state.searchQueryData.sort) {
                if (state.searchQueryData.sort.value === 'ASCENDING') {
                    filteredProjects = filteredProjects.sort((a, b) => (a.name > b.name) ? 1 : -1);
                } else {
                    filteredProjects = filteredProjects.sort((a, b) => (a.name > b.name) ? -1 : 1);
                }
            }
            return filteredProjects
        } else {
            return allProjects
        }
    },
    getQueryData: (state) => {
        return state.searchQueryData
    },
    getValidationTableHeaderData: (state) => {
        return state.validationTableHeaderData
    },
    getValidationTable: (state) => {
        let filters = state.validationTableHeaderData.filters
        let sort = state.validationTableHeaderData
        //let filteredTable = state.validationData
        console.log('Filters: ', filters, sort)

        let table = []
        table = state.validationData.map((td) => {
            return mapValidationData(td)
        })

        let filteredStartTime = filters && filters.eventAt ? getDateInTimeZone(filters.eventAt) : null
        let filteredEndTime = filters && filters.eventEnd ? getDateInTimeZone(filters.eventEnd) : null

        console.log('Core indicators: ', filters.coreIndicators)


        let filteredTable = table.filter(dt => filteredStartTime ? filteredStartTime === getDateInTimeZone(new Date(dt.eventAt)) : true)
        //filteredTable = filteredTable.filter(dt => filteredEndTime ? filteredEndTime === getDateInTimeZone(new Date(dt.eventEnd)) : true)
        filteredTable = filteredTable.filter(dt => filters && filters.eventValid && filters.eventValid.length > 0 ? filters.eventValid.includes(dt.eventValid) : true)
        //filteredTable = filteredTable.filter(dt => filters && filters.coreIndicators && filters.coreIndicators.length > 0 ? isSubarray(dt.coreIndicators, filters.coreIndicators) : true)
        filteredTable = filteredTable.filter(dt => filters && filters.severityRating != null && filters.severityRating.length > 0 ? dt.severityRating && dt.severityRating.length > 0 ? dt.severityRating.toString().toLowerCase().includes(filters.severityRating.toLowerCase()) : false : true)
        filteredTable = filteredTable.filter(dt => filters && filters.operator != null && filters.operator.length > 0 ? dt.operator && dt.operator.length > 0 ? dt.operator.toString().toLowerCase().includes(filters.operator.toLowerCase()) : false : true)
        //filteredTable = filteredTable.filter(dt => filterNumberMax(filters.speed, dt.lSpeed, dt.fSpeed))
/*        filteredTable = filteredTable.filter(dt => filterNumberMax(filters.petValue, dt.petValue))
        filteredTable = filteredTable.filter(dt => filters && filters.eventType != null && filters.eventType.length > 0 ? dt.eventType && dt.eventType.length > 0 ? dt.eventType.toString().toLowerCase().includes(filters.eventType.toLowerCase()) : false : true)
        filteredTable = filteredTable.filter(dt => filters && filters.eventClass != null && filters.eventClass.length > 0 ? dt.eventClass && dt.eventClass.length > 0 ? dt.eventClass.toString().toLowerCase().includes(filters.eventClass.toLowerCase()) : false : true)*/

        return filteredTable
    },
    getSelectedEvent: (state) => {
        return state.selectedEvent
    },

}
